import { render } from "./DishCard.vue?vue&type=template&id=0194dee0&scoped=true"
import script from "./DishCard.vue?vue&type=script&lang=js"
export * from "./DishCard.vue?vue&type=script&lang=js"

import "./DishCard.vue?vue&type=style&index=0&id=0194dee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0194dee0"]])

export default __exports__